// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"a252a221","440":"88494da4","453":"b663817d","547":"720d1c48","882":"8cab1832","966":"4d5084c9","975":"456abe2d"}[chunkId] + ".chunk.js";
};